import React from 'react';
import cx from 'classnames';
import useAvatar from '../../../hooks/useAvatar';

interface ProfileImageProps extends React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
> {
  user: string;
  alt?: string;
  className?: string;
  style?: any;
}

const ProfileImage = ({ user: userId, alt = 'Profile image', className, style, ...props }: ProfileImageProps) => {
  const classNames = cx('avatar', className);
  const avatar = useAvatar(userId);

  return (
    <img
      className={classNames}
      style={{
        objectFit: 'cover',
        borderRadius: '100%',
        ...style
      }}
      src={avatar ?? undefined}
      alt={alt || 'VL'}
      {...props}
    />
  );
};

export default ProfileImage;
